import {
  EmailChangeCard,
  getHistoryState,
  JoinCard,
  LoginCard,
  PasswordResetCard,
} from "@indietabletop/appkit";
import { Page } from "../oss/Layout/Layout";
import { wrapper } from "./style.css";

export function LoginPage() {
  return (
    <Page title="Account" backHref="~/">
      <div className={wrapper}>
        <LoginCard
          description={
            "Log into your Indie Tabletop Club account to unlock owned content and enable backup & sync."
          }
          defaultValues={{ email: getHistoryState()?.emailValue }}
        />
      </div>
    </Page>
  );
}

export function PasswordResetPage() {
  return (
    <Page title="Account" backHref="~/">
      <div className={wrapper}>
        <PasswordResetCard
          defaultValues={{ email: getHistoryState()?.emailValue }}
        />
      </div>
    </Page>
  );
}

export function JoinPage() {
  return (
    <Page title="Account" backHref="~/">
      <div className={wrapper}>
        <JoinCard defaultValues={{ email: getHistoryState()?.emailValue }} />
      </div>
    </Page>
  );
}

export function EmailChangePage() {
  return (
    <Page title="Account" backHref="~/">
      <div className={wrapper}>
        <EmailChangeCard />
      </div>
    </Page>
  );
}
